<mat-dialog-content>
  <section class="w3l-hero-headers-11 p-sticky-md">
    <div class="top-header">
      <div class="d-grid grid-columns-top-3">
        <div class="accounts">
          <ul>
            <li></li>
            <li></li>
          </ul>
        </div>

      </div>
    </div>
    <div id="w3l-appointment" class="styled-input">
      <div class="appointment-form-field ">
          <input type="text" name="ComplaintSearch" placeholder="Complaint Search" (change)="RetriveComplainsLookup()" [(ngModel)]="thname" required="" style="width: 80%;"/>
      </div>
    </div>

  </section>

  <table>
    <thead>
      <tr>
        <th style="width: 100%;">Complaint</th>
        <th style="width: 20%;">Choose</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let Do of ComplaintList; let i = index">
        <td data-column="Doctor Name">{{Do.thname}}</td>

        <td data-column="Choose"><button type="button" class="theme-button btn" id="select" name="select"
            (click)="Selectcomplains(Do)">Select</button>
        </td>
      </tr>

    </tbody>
  </table>
</mat-dialog-content>
